import React from "react";
import clsx from "clsx";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import useStyles from "./styles";
import { get, size } from "lodash";

const ButtonSteps = ({
  name,
  steps,
  activeStep,
  setActiveStep,
  errors,
  completed
}) => {
  const classes = useStyles();

  const handleStep = step => () => setActiveStep(step);

  const customStepIcon = props => {
    const classes = useStyles();
    const { active, error } = props;
    return (
      <span
        className={clsx(classes.customStepIcon, {
          [classes.activeStep]: active,
          [classes.errorStep]: error
        })}></span>
    );
  };

  return (
    <Stepper
      activeStep={activeStep}
      orientation="vertical"
      className={`${classes.stepperMenu} " " ${completed ? classes.pointerNone : ""
        }`}>
      {(steps || []).map((item, index) => {
        const { wrapper } = item;
        const errorWrapper = get(errors, `${name}.${wrapper}`);
        const labelProps = {};
        const stepProps = {
          completed: false
        };

        if (size(errorWrapper) > 0) {
          labelProps.optional = (
            <span className="error-msg">{`${size(
              errorWrapper
            )} errors`}</span>
          );
          labelProps.error = true;
        }

        return (
          <Step key={wrapper} {...stepProps}>
            <StepLabel
              {...labelProps}
              onClick={handleStep(index)}
              className={classes.stepLabel}
              StepIconComponent={customStepIcon}>
              {item.label}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
};

export default ButtonSteps;
